import './ccf-phone-inbound-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPhoneInboundIconProps extends SvgIconProps {}

/**
 * Component displays phone inbound icon
 * @param props -CcfPhoneInboundIconProps
 * @returns phone inbound svg icon
 * @example <CcfPhoneInboundIcon/>
 */
export function CcfPhoneInboundIcon(props: CcfPhoneInboundIconProps) {
  return (
    <SvgIcon viewBox="0 0 16.8 18" {...props}>
      <path className="a" d="M10.644-30.967S9.921-29.8,9.854-29.7s-.207.393-.88.194c-.739-.218-2.012-.833-3.991-2.878A10.152,10.152,0,0,1,2.2-36.506c-.192-.7.092-.841.188-.91s1.227-.816,1.227-.816c.761-.461-.1-2.434-1.488-3.383C1.1-42.316.648-42.248.218-41.9a11.092,11.092,0,0,0-1.869,1.979,1.929,1.929,0,0,0-.327,1.351A11.536,11.536,0,0,0-.45-34.325,20.33,20.33,0,0,0,2.768-30.1,19.925,19.925,0,0,0,6.862-26.77a10.7,10.7,0,0,0,4.112,1.579,1.783,1.783,0,0,0,1.307-.338A11.068,11.068,0,0,0,14.2-27.46c.334-.445.4-.909-.278-1.969C13-30.864,11.091-31.753,10.644-30.967Z" transform="translate(2 43.169)"/><g transform="translate(8.067)"><g transform="translate(0 0)"><path className="a" d="M1.7,8.722l3.8-3.932,1.5,1.552c.26.266.53.183.605-.188L8.72.549c.07-.368-.161-.612-.52-.534L2.776,1.158c-.359.078-.439.357-.182.625l1.5,1.549-3.8,3.93a1.058,1.058,0,0,0,0,1.46A.979.979,0,0,0,1.7,8.722Z" transform="translate(8.733 9.022) rotate(180)"/></g></g>
    </SvgIcon>
  );
}

export default CcfPhoneInboundIcon;
